(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.NSolverRouter = (function(superClass) {
    extend(NSolverRouter, superClass);

    function NSolverRouter() {
      return NSolverRouter.__super__.constructor.apply(this, arguments);
    }

    NSolverRouter.prototype.prefix = 'NSolver';

    NSolverRouter.prototype.module_name = 'NSolverRouter';

    NSolverRouter.prototype.register = function() {
      var i, len, ref, widget;
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('grower::Angular/NSolver/NSolverService', ['$http', '$rootScope', '$state', '$stateParams', '$q', 'Core.Services.Session']);
      this.controller('grower::Angular/NSolver/SidebarController', ['$scope', '$transitions', 'NSolver.Services.NSolverService', '$state', '$q', '$stateParams', '$http', '$timeout', '$uibModal', '$window']);
      this.controller('grower::Angular/NSolver/StepsController', ['$scope', '$transitions', 'NSolver.Services.NSolverService', '$state', '$uibModal', '$http', '$window', '$timeout'], 'StepsController');
      ref = ['FieldSelection', 'ManagementIntensity', 'Events', 'TillagePractice', 'SeasonDetails', 'ApplicationDetails'];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        this.controller("grower::Angular/NSolver/Widgets/" + widget + "Controller", ['$scope', '$transitions', '$uibModal', '$http', 'NSolver.Services.NSolverService', '$state', '$q', '$ngModal'], widget + "WidgetController");
      }
      return this.controller('grower::Angular/Operation/Machinery/ModalMachineryController', ['$scope', '$transitions', '$uibModal', '$uibModalInstance', 'Operation.Services.Machinery', '$q', 'viewing', 'editing', 'id', 'typeId', 'autoSelect']);
    };

    NSolverRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('grower.nsolver', {
        url: '/nsolver',
        templateUrl: 'backend/grower/nsolver/sidebar',
        controller: 'NSolver.Controllers.SidebarController'
      }).state('grower.nsolver.step', {
        url: '/:id/step/:step',
        params: {
          id: {
            type: 'int',
            dynamic: true,
            squash: false
          },
          step: {
            type: 'int',
            value: 1,
            dynamic: true,
            squash: false
          }
        },
        views: {
          fullpage: {
            templateUrl: 'backend/grower/nsolver/steps'
          }
        }
      });
    };

    return NSolverRouter;

  })(Router);

}).call(this);
